import {
  apiRequest,
  identitasDetail,
  identitasUpdate,
  masterRegion,
  masterReligion,
  masterBloodType,
  masterMaritalStatus,
  masterBank,
  masterEmployeeType,
  masterEmployeeStatus,
  masterEmployeeStatusDescription,
  masterEmployeeStatusPosition,
  masterWorkUnit,
  deleteFotoAbsen,
  masterGajiwebSatker,
  masterGajiwebBankSpan,
  masterEmployee,
} from "../../../../../services/adapters/kepegawaian/indentitasService";

class UpdateRepository {
  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchReligion = async (query) => {
    return await apiRequest(
      "get",
      masterReligion,
      {
        params: query,
      },
      true
    );
  };

  fetchBloodType = async (query) => {
    return await apiRequest(
      "get",
      masterBloodType,
      {
        params: query,
      },
      true
    );
  };

  fetchMaritalStatus = async (query) => {
    return await apiRequest(
      "get",
      masterMaritalStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchBank = async (query) => {
    return await apiRequest(
      "get",
      masterBank,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeType = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeType,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatus = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatusDescription = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatusDescription,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatusPosition = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatusPosition,
      {
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileDistrict = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDomicileVillage = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityDistrict = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchIdentityVillage = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      identitasDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      identitasUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      deleteFotoAbsen,
      {
        body: query,
      },
      true
    );
  };

  fetchSatkerGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebSatker,
      {
        params: query,
      },
      true
    );
  };

  fetchBankSpanGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebBankSpan,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      masterEmployee,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
